import { SubscriptionEvent } from '@fiverr-private/bianka_js/protobuf/bianka/event/activity/v2/extension/subscription/subscription';
import { biEvent } from '..';
import type { RequestUpgradeModalProps } from '../../entries/RequestUpgradeModal';
import { CONVERT_PLAN_TYPE_TO_PACKAGE_TYPE } from '../consts';

interface RequestUpgradeEventParams
    extends Pick<RequestUpgradeModalProps, 'currentPlan' | 'pageName' | 'sellerId' | 'upgradeSource'> {}

export const reportClickedOnRequestUpgradeTrigger = ({
    pageName,
    currentPlan,
    sellerId,
    upgradeSource,
}: RequestUpgradeEventParams) => {
    biEvent.click<SubscriptionEvent>(pageName, {
        event: {
            type: 'clicked_pro_subscription_advanced_plan_request_upgrade',
            element: {
                name: 'pro_subscription_advanced_plan_request_upgrade',
                text: { value: upgradeSource || '' },
            },
            ...(sellerId ? { seller: { id: sellerId } } : {}),
        },
        additionalData: {
            type: SubscriptionEvent,
            message: {
                currentPlan: CONVERT_PLAN_TYPE_TO_PACKAGE_TYPE[currentPlan],
                targetPlan: CONVERT_PLAN_TYPE_TO_PACKAGE_TYPE.pro_advanced,
            },
        },
    });
};

export const reportClickedOnRequestUpgradeSend = ({
    pageName,
    currentPlan,
    upgradeSource,
    sellerId,
}: RequestUpgradeEventParams) => {
    biEvent.click<SubscriptionEvent>(pageName, {
        event: {
            type: 'clicked_pro_subscription_advanced_upgrade_send_request',
            element: {
                name: 'pro_subscription_advanced_upgrade_send_request',
                text: { value: upgradeSource || '' },
            },
            ...(sellerId ? { seller: { id: sellerId } } : {}),
        },
        additionalData: {
            type: SubscriptionEvent,
            message: {
                currentPlan: CONVERT_PLAN_TYPE_TO_PACKAGE_TYPE[currentPlan],
                targetPlan: CONVERT_PLAN_TYPE_TO_PACKAGE_TYPE.pro_advanced,
            },
        },
    });
};
